var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{ref:"page",staticClass:"reports-page"},[_c('iframe',{ref:"iframe",staticClass:"metabase",attrs:{"allowtransparency":"","src":_vm.dashboardUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }